import { IAction } from "../model/IAction";

export const UPDATE_NAME = "UPDATE_NAME";
export function updateName(newName: string): UpdateNameAction {
  return {
    type: UPDATE_NAME,
    updatedName: newName
  };
}
export interface UpdateNameAction extends IAction {
  updatedName: string;
}
